/* ARRAY - SHOP BY CATEGORY. The featured category moves every four seconds,
   and pointing at a small cell features it immediately.

   WHAT THE CLIENT ASKED FOR ORIGINALLY, EXACTLY: "after three seconds the lips
   will come and the skincare will go at the place of lips". That is a SWAP
   between the big cell and the cell the incoming category came from - not a
   rotation of everything by one. The partner cell walks 1,2,3,4 and repeats, so
   every category is featured once per five ticks.

   HOVER PROMOTES, IT DOES NOT PAUSE (added 18 Sep 2026, when he asked for the
   section to "interact with the customers"). Pointing at a small cell swaps it
   into the big cell at once and restarts the countdown from zero, so the
   visitor steers it and still gets a full interval to read what they picked.
   THE TIMER IS NEVER SUSPENDED: he tried a hover pause here once, found the
   section frozen under his cursor and asked for the clock to keep running "no
   matter what happens". If a pause is ever wanted back, remember it also has to
   pause the progress bar or the two drift apart.

   TOUCH IS EXCLUDED from the promote. On a phone a tap is a click and the face
   is an <a>, so intercepting it would either eat the navigation or fire on the
   way to it. pointerType 'touch' returns early and the auto-rotation carries
   those visitors.

   THE PROMOTE ALSO RE-AIMS `partner`. After a hover swap the next automatic
   tick must not immediately undo it, so partner moves to the cell after the one
   that was just promoted, exactly as a natural tick would have left it.

   NOTHING MOVES OR RESIZES. Every cell already contains all five categories as
   stacked faces; a tick only re-points which face is opaque in the two cells
   that changed. Moving one element into another grid area would jump and
   resize, which this client has rejected three times elsewhere on this site.

   THE PROGRESS BAR IS A WEB ANIMATION, not a CSS animation. It has to restart
   from zero on the same tick that swaps the cells, and `animate()` does that in
   one call; a CSS animation needs a class toggle plus a forced reflow to
   replay and drifts out of step. It lives on the bottom edge of the big cell so
   it reads as the countdown for the thing that is actually changing.

   `order` is the whole model: order[cell] = category index. The DOM is never
   re-ordered. THE SCRIPT IS AGNOSTIC ABOUT HOW MANY CELLS THERE ARE - it reads
   them from the DOM, so the six-cell and five-cell layouts both run on this
   file unchanged.
*/
(function () {
  'use strict';

  function build(root) {
    if (root.__cg) return;
    root.__cg = true;

    var cells = [].slice.call(root.querySelectorAll('[data-cg-slot]'));
    var n = cells.length;
    if (n < 2) return;

    var bar = root.querySelector('[data-cg-prog]');
    var wait = parseInt(root.getAttribute('data-interval'), 10) || 4000;
    var order = [], i;
    for (i = 0; i < n; i++) order.push(i);

    var partner = 1, timer = null, anim = null;

    function paint() {
      for (var c = 0; c < n; c++) {
        var faces = cells[c].querySelectorAll('[data-cg-face]');
        for (var j = 0; j < faces.length; j++) {
          var on = (j === order[c]);
          faces[j].classList.toggle('is-on', on);
          faces[j].setAttribute('aria-hidden', on ? 'false' : 'true');
          faces[j].tabIndex = on ? 0 : -1;
        }
      }
    }

    function runBar() {
      if (!bar || !bar.animate) return;
      if (anim) { anim.cancel(); anim = null; }
      anim = bar.animate(
        [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
        { duration: wait, easing: 'linear', fill: 'forwards' }
      );
    }

    function restart() {
      if (timer) clearInterval(timer);
      timer = setInterval(step, wait);
      runBar();
    }

    function swap(cell) {
      var a = order[0];
      order[0] = order[cell];
      order[cell] = a;
      partner = cell + 1;
      if (partner >= n) partner = 1;
      paint();
    }

    function step() {
      swap(partner);
      runBar();
    }

    for (i = 1; i < n; i++) {
      (function (idx) {
        cells[idx].addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'touch') return;
          if (order[idx] === order[0]) return;
          swap(idx);
          restart();
        });
      })(i);
    }

    paint();
    runBar();
    timer = setInterval(step, wait);
  }

  function boot() {
    var list = document.querySelectorAll('[data-cg-root]'), i;
    for (i = 0; i < list.length; i++) build(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
